module.exports = __webpack_public_path__ + "static/media/OVATO_WHITEPAPER_KOREAN.1c89330d.pdf";